import UsersTableFilter from "./users-table-filter";


const UsersFilters = {
    Table: UsersTableFilter,
};

export default UsersFilters;